const PESOS_DV1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const PESOS_DV2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const REGEX_BASE_VALIDA = /^[A-Z0-9]{12}$/;
const REGEX_DV = /^\d{2}$/;

export function normalizarCnpj(valor: string | null | undefined): string {
  if (!valor) return '';
  return valor.toString().toUpperCase().replace(/[^A-Z0-9]/g, '');
}

function somaPonderada(base: string, pesos: number[]): number {
  let soma = 0;
  for (let i = 0; i < pesos.length; i++) {
    soma += (base.charCodeAt(i) - 48) * pesos[i];
  }
  return soma;
}

function dvFromSoma(soma: number): number {
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

export function calcularDvCnpj(base12: string): string {
  const base = normalizarCnpj(base12);
  if (!REGEX_BASE_VALIDA.test(base)) return '';
  const dv1 = dvFromSoma(somaPonderada(base, PESOS_DV1));
  const dv2 = dvFromSoma(somaPonderada(base + dv1, PESOS_DV2));
  return `${dv1}${dv2}`;
}

export function isCnpjAlfanumerico(cnpj: string | null | undefined): boolean {
  const base = normalizarCnpj(cnpj).substring(0, 12);
  return /[A-Z]/.test(base);
}

export function isCnpjValido(cnpj: string | null | undefined): boolean {
  const limpo = normalizarCnpj(cnpj);
  if (limpo.length !== 14) return false;

  const base = limpo.substring(0, 12);
  const dvInformado = limpo.substring(12);

  if (!REGEX_BASE_VALIDA.test(base) || !REGEX_DV.test(dvInformado)) return false;

  if (/^(.)\1{13}$/.test(limpo)) return false;

  return calcularDvCnpj(base) === dvInformado;
}

export function formatarCnpj(cnpj: string | null | undefined): string {
  const limpo = normalizarCnpj(cnpj);
  if (limpo.length !== 14) return cnpj ?? '';
  return `${limpo.substring(0, 2)}.${limpo.substring(2, 5)}.${limpo.substring(5, 8)}/${limpo.substring(8, 12)}-${limpo.substring(12)}`;
}
